export default {
  install(Vue) {
    /**
     * @description Преобразует объект JS в объект FormData. Вложенные объекты не обрабатываются. Массивы обрабатываются.
     * @param data
     * @return {FormData}
     */
    Vue.prototype.$getFormData = (data = {}) => {
      let formData = new FormData()
      for (let key in data) {
        if (typeof data[key] === 'number' || typeof data[key] === 'string') {
          formData.set(`${key}`, data[key])
        }
        if (Array.isArray(data[key])) {
          if (data[key].length > 0) {
            for (let i = 0; i < data[key].length; i++) {
              formData.append(`${key}[]`, data[key][i])
            }
          }
        }
      }
      return formData
    }
  },
}
